import React, { FC } from 'react';
import { ExtendedRunStatus, IConversationRun } from '../model/ConversationRun';
import { useConversationRun } from './hooks/useConversationRun';
import { AssistantResponse } from './AssistantResponse';
import { ChatBubble } from 'features/pi/view/uiManager/text-instances/chat-bubble/chat-bubble';
import styles from './conversation-message.module.scss';
import { ChatLoader } from './ChatLoader';

export interface ConversationRunProps {
    run: IConversationRun;
    isLastRun: boolean;
}

const FailedAssistantResponse = () => {
    // will be developed later
    return (
        <div
            data-testid="failed-assistant-response"
            style={{
                backgroundColor: '#b00020',
                padding: '5px',
            }}
        >
            The assistant failed to respond. Please try again later or contact support if the issue
            persists.
        </div>
    );
};

export const ConversationRun: FC<ConversationRunProps> = (props) => {
    const { run, isLastRun } = props;
    const { input, containers, status } = useConversationRun(run);

    let responseComponent = null;
    if (status === ExtendedRunStatus.FAILED || status === ExtendedRunStatus.CLIENT_ERROR) {
        responseComponent = <FailedAssistantResponse />;
    } else if (
        status === ExtendedRunStatus.PENDING ||
        (status === ExtendedRunStatus.RUNNING && containers.length === 0)
    ) {
        responseComponent = <ChatLoader />;
    } else {
        responseComponent = <AssistantResponse run={run} isLastRun={isLastRun} />;
    }

    return (
        <div data-testid="conversation-run" className={styles.container}>
            <span className={styles.userInput}>
                <ChatBubble text={input} additionalContainerClassName={styles.chatBubble} />
            </span>
            {responseComponent}
        </div>
    );
};
